// extracted by mini-css-extract-plugin
export default {"marker":"map-point-builder_marker__71kc7","marker-default":"map-point-builder_marker-default__RxTW3","distance-label":"map-point-builder_distance-label__39es7"};